import CJBestMessageSender from './CJBestMessageSender';

export default CJBestMessageSender;
